<template>
  <main class="main-content" id="main-content">
      <div class="container">
        <section class="section">
          <page-header>
              <template v-slot:pageTitle>
                {{ $t("branches") }}
              </template>
          </page-header>
          <div class="section__body">

            <div class="map-wrapper">


              <div class="map-area">
                <div id="branches-map" class="leaflet-map"></div>
                <div class="cov-glow"></div>
              </div>

            </div>

          </div>
        </section>
      </div>
  </main>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default {
components: { PageHeader },

data() {
  return {
    map: null,
    locations: [
      { name: "Астана",      coords: [51.1605, 71.4704] },
      { name: "Алматы", coords: [43.2389, 76.8897] },
      { name: "Шымкент",     coords: [42.3000, 69.6000] },
      { name: "Тараз",       coords: [42.9000, 71.3667] },
      { name: "Кызылорда",   coords: [44.8479, 65.5093] },
      { name: "Актау",       coords: [43.6500, 51.1833] },
      { name: "Атырау",      coords: [47.1167, 51.8833] },
      { name: "Актобе",      coords: [50.2839, 57.1670] },
      { name: "Костанай",    coords: [53.2141, 63.6319] },
      { name: "Кокшетау",    coords: [53.2833, 69.3833] },
      { name: "Қарағанды",   coords: [49.8047, 73.1094] },
      { name: "Павлодар",    coords: [52.2873, 76.9674] },
      { name: "Семей",       coords: [50.4111, 80.2275] },
      { name: "Өскемен",     coords: [49.9727, 82.6059] },
    ],
  };
},

mounted() {
  this.$nextTick(() => this.initMap());
},

beforeDestroy() {
  if (this.map) {
    this.map.remove();
    this.map = null;
  }
  window.removeEventListener("resize", this.handleResize);
},

methods: {
  initMap() {
    this.map = L.map("branches-map", {
      center: [48.0196, 79.9237],
      zoom: 5,
      zoomControl: true,
      attributionControl: false,
      scrollWheelZoom: false,
    });

    // Светлая тайловая подложка
    L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
    ).addTo(this.map);

    // Границы Казахстана
    fetch(
      "https://raw.githubusercontent.com/johan/world.geo.json/master/countries/KAZ.geo.json"
    )
      .then((res) => res.json())
      .then((data) => {
        L.geoJSON(data, {
          style: {
            fillColor: "#2ca449",
            fillOpacity: 0.1,
            color: "#2ca449",
            weight: 2,
          },
        }).addTo(this.map);
      });

    // Маркеры
    this.locations.forEach((loc) => {
      const dotIcon = L.divIcon({
        className: "",
        html: `<div class="mp-dot-vue"></div>`,
        iconSize: [12, 12],
        iconAnchor: [6, 6],
      });

      const textIcon = L.divIcon({
        className: "custom-city-label-vue",
        html: `<span>${loc.name}</span>`,
        iconAnchor: [-14, 8],
      });

      L.marker(loc.coords, { icon: dotIcon }).addTo(this.map);
      L.marker(loc.coords, { icon: textIcon }).addTo(this.map);
    });

    window.addEventListener("resize", this.handleResize);
  },

  handleResize() {
    if (this.map) this.map.invalidateSize();
  },
},
};
</script>

<style scoped>
/* ── Обёртка ── */
.section__body{
  height: 100vh;
}
.map-wrapper {
border: 1px solid #e5e7eb;
border-radius: 16px;
overflow: hidden;
background: #ffffff;
box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
height: 80%;
}

/* ── Шапка ── */
.cov-header {
display: flex;
justify-content: space-between;
align-items: center;
padding: 14px 24px;
border-bottom: 1px solid #f0f2f5;
background: #fafafa;
}
.cov-header-left {
display: flex;
align-items: center;
gap: 10px;
}
.cov-dot {
width: 8px;
height: 8px;
border-radius: 50%;
background: #10b981;
box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15);
}
.cov-title {
font-size: 13px;
font-weight: 600;
color: #111827;
}
.cov-url {
font-family: monospace;
font-size: 12px;
color: #9ca3af;
}

/* ── Карта ── */
.map-area {
position: relative;
aspect-ratio: 2.4 / 1;
overflow: hidden;
background: #f8fafc;
height: 100%;
}
.leaflet-map {
width: 100%;
height: 100%;
z-index: 1;
}
.cov-glow {
position: absolute;
top: 10%;
left: 15%;
width: 70%;
height: 80%;
z-index: 2;
pointer-events: none;
background: radial-gradient(
  ellipse 100% 80% at 50% 50%,
  rgba(44, 164, 73, 0.06),
  rgba(44, 164, 73, 0.03) 50%,
  transparent 70%
);
border-radius: 50%;
filter: blur(24px);
}

/* ── Подвал ── */
.cov-footer {
display: flex;
justify-content: space-between;
align-items: center;
padding: 12px 24px;
border-top: 1px solid #f0f2f5;
background: #fafafa;
}
.cov-legend {
display: flex;
gap: 20px;
}
.cov-legend-item {
display: flex;
align-items: center;
gap: 6px;
font-size: 12px;
color: #6b7280;
font-weight: 500;
}
.legend-dot {
width: 8px;
height: 8px;
border-radius: 50%;
flex-shrink: 0;
}
.cov-link {
display: flex;
align-items: center;
gap: 4px;
font-size: 13px;
color: #2ca449;
text-decoration: none;
font-weight: 600;
transition: opacity 0.2s;
}
.cov-link:hover {
opacity: 0.75;
}

/* ── Статистика ── */
.cov-status {
display: flex;
gap: 12px;
margin-top: 16px;
}
.cov-stat {
background: #ffffff;
border: 1px solid #e5e7eb;
border-radius: 12px;
padding: 18px 16px;
flex: 1;
text-align: center;
box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
transition: box-shadow 0.2s;
}
.cov-stat:hover {
box-shadow: 0 4px 12px rgba(44, 164, 73, 0.1);
border-color: #bbf7d0;
}
.cov-stat-val {
font-size: 22px;
font-weight: 800;
color: #2ca449;
letter-spacing: -0.5px;
margin-bottom: 4px;
}
.cov-stat-lbl {
font-size: 12px;
color: #9ca3af;
font-weight: 500;
}

/* ── Адаптив ── */
@media (max-width: 768px) {
.cov-status {
  flex-wrap: wrap;
}
.cov-stat {
  flex: 1 1 calc(50% - 6px);
}
.map-area {
  aspect-ratio: 1.4 / 1;
}
.cov-footer {
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}
}

@media (max-width: 480px) {
.cov-stat {
  flex: 1 1 100%;
}
}
</style>

<!-- Глобальные стили для Leaflet-маркеров -->
<style>
.mp-dot-vue {
width: 12px;
height: 12px;
border-radius: 50%;
background: #2ca449;
border: 2px solid #ffffff;
box-shadow: 0 0 0 3px rgba(44, 164, 73, 0.25),
            0 0 10px rgba(44, 164, 73, 0.3);
animation: mpPulseVue 2s ease-in-out infinite;
}
@keyframes mpPulseVue {
0%, 100% {
  box-shadow: 0 0 0 3px rgba(44, 164, 73, 0.25),
              0 0 10px rgba(44, 164, 73, 0.3);
}
50% {
  box-shadow: 0 0 0 6px rgba(44, 164, 73, 0.1),
              0 0 18px rgba(44, 164, 73, 0.2);
}
}

.custom-city-label-vue {
font-family: monospace;
font-size: 10px;
font-weight: 700;
color: #065f46;
white-space: nowrap;
background: #ffffff;
padding: 3px 8px;
border-radius: 6px;
border: 1px solid #d1fae5;
box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
pointer-events: none;
}

/* Скрываем копирайт Leaflet если мешает */
.leaflet-control-attribution {
display: none !important;
}
</style>